'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createQueryStateMachine = createQueryStateMachine;
exports.createCommandStateMachine = createCommandStateMachine;

var _stately = require('stately.js');

var _stately2 = _interopRequireDefault(_stately);

var _CallState = require('./CallState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// for simplify work with stately.js
var states = {
    CREATED: _CallState.CallState.CREATED.name,
    IN_PROGRESS: _CallState.CallState.IN_PROGRESS.name,
    SUCCESS: _CallState.CallState.SUCCESS.name,
    FAILURE: _CallState.CallState.FAILURE.name
};

var queryStateMachineDescription = {
    CREATED: {
        execute: states.IN_PROGRESS
    },
    IN_PROGRESS: {
        finishWithSuccess: states.SUCCESS,
        finishWithError: states.FAILURE,
        execute: function execute() {
            throw new Error('query already in progress');
        }
    },
    SUCCESS: {
        execute: function execute() {
            throw new Error('query already finished');
        }
    },
    FAILURE: {
        execute: function execute() {
            throw new Error('query already finished');
        }
    }
};

var commandStateMachineDescription = {
    CREATED: {
        execute: states.IN_PROGRESS
    },
    IN_PROGRESS: {
        finishWithSuccess: states.SUCCESS,
        finishWithError: states.FAILURE,
        execute: function execute() {
            throw new Error('query already in progress');
        }
    },
    SUCCESS: {
        execute: function execute() {
            throw new Error('command already finished');
        }
    },
    FAILURE: {
        execute: states.IN_PROGRESS
    }
};

function createQueryStateMachine() {
    return _stately2.default.machine(queryStateMachineDescription, states.CREATED);
}

function createCommandStateMachine() {
    return _stately2.default.machine(commandStateMachineDescription, states.CREATED);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/CallStateFSM.js
// module id = 1419
// module chunks = 118